var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayTuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLAY",
    transform: "translate(-1610.953 -1028.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    transform: "translate(1610.953 1028.54)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 35.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-play",
    "data-name": "Icon awesome-play",
    d: "M29.841,16.88,5.091.519C3.08-.81,0,.479,0,3.766V36.48c0,2.948,2.862,4.725,5.091,3.247l24.75-16.353A4.008,4.008,0,0,0,29.841,16.88Z",
    transform: "translate(1636.205 1045.91)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayTuto);
export default __webpack_public_path__ + "static/media/play-tuto.ea23e9f5.svg";
export { ForwardRef as ReactComponent };